import PageApp from 'pageApp';
import {
  Actions,
  AddToRegistry,
  ApplicationMessages,
  Timeouts,
} from '../util/Constants';
import AddToRegistryModel from './AddToRegistryModel';
import {
  format,
  CURRENCY,
} from '../util/TealiumFormattingUtil';

export default class AddToRegistryController {
  constructor(options) {
    Object.assign(this, options);
  }

  fireAddToRegistryCall() {
    const addToRegistryModel = new AddToRegistryModel({}, {
      productModel: this.productModel,
      source: this.source,
    });
    const currentData = {
      productId: addToRegistryModel.get('productId'),
      quantity: addToRegistryModel.get('quantity'),
      color: addToRegistryModel.get('color'),
      size: addToRegistryModel.get('size'),
      type: addToRegistryModel.get('type'),
    };
    this.toggleLoading(true);
    addToRegistryModel.currentUrl = `${AddToRegistry.addToRegistryUrl}`;
    addToRegistryModel.save(null, {
      success: this.handleSuccess.bind(this),
      error: this.handleError.bind(this),
      attrs: currentData,
      timeout: Timeouts.async,
    });
  }

  static fireLinkTag(model) {
    const viewState = model.productModel.get('viewState');
    const product = model.productModel.get('product');
    const upcId = viewState.detail.selectedUpc.toString();
    const selectedPrice = model.get('selectedPrice');
    const data = {
      event_name: 'registry add',
      product_color: format(model.get('color')),
      product_id: format(model.get('productId')),
      product_name: format(model.get('name')),
      product_quantity: format(model.get('quantity')),
      product_size: format(model.get('size')),
      product_upc: format(product.relationships.upcs[upcId].identifier.upcNumber),
    };

    if (model.productModel.get('utagData') === undefined) {
      const productPrice = selectedPrice.price.tieredPrice[selectedPrice.price.tieredPrice.length - 1].values[0].value;
      const productData = model.productModel.collection.productModel.get('product');
      Object.assign(data, {
        product_category_id: format(productData.identifier.topLevelCategoryID),
        product_category_name: format(productData.identifier.topLevelCategoryName),
        product_sub_total: format(productPrice * (viewState.detail.selectedQuantity), CURRENCY),
        product_original_price: selectedPrice.price.tieredPrice[0].values[0].value,
        product_price: format(productPrice, CURRENCY),
      });
    } else {
      const productData = model.productModel.get('product');
      const utagData = model.productModel.get('utagData');
      // Quickfix => break second time addToRegistry is call @todo avoid product model be modified after first call
      const unformatPrice = utagData.product_price.length > 0 ? format(utagData.product_price[0], CURRENCY) : '';
      Object.assign(data, {
        product_category_id: format(productData.identifier.topLevelCategoryID),
        product_category_name: format(productData.identifier.topLevelCategoryName),
        product_price: utagData.product_price,
        product_original_price: utagData.product_original_price,
        product_sub_total: format(unformatPrice * (viewState.detail.selectedQuantity), CURRENCY),
      });
    }

    PageApp.channel.trigger(Actions.tealium.linkTag, data);
  }

  handleSuccess(model, response) {
    this.toggleLoading(false);

    if (!response.SIGNED_IN && response.REDIRECT) {
      PageApp.channel.trigger(Actions.page.redirect, response.REDIRECT);
      return;
    }

    if (response.errorMsg) {
      this.handleError(model, response);
      return;
    }

    if (response.SIGNED_IN && response.HAS_REGISTRY === 'NO') {
      PageApp.channel.trigger(Actions.product.registry.success, {
        responseData: response,
        productModel: this.productModel,
      });
      return;
    }

    AddToRegistryController.fireLinkTag(model);

    PageApp.channel.trigger(Actions.product.registry.success, {
      responseData: model.toJSON(),
      productModel: this.productModel,
    });
  }

  toggleLoading(toggle) {
    const { showLoader, hideLoader } = Actions.product.ctaButton;
    const action = toggle ? showLoader : hideLoader;
    const eventName = `${action}:${this.eventId}`;

    PageApp.channel.trigger(eventName, this.$currentTarget);
  }

  handleError(model, response) {
    const message = response.errorMsg || ApplicationMessages.technicalIssue;
    PageApp.channel.trigger(`${Actions.product.ctaNotification.error}:${this.eventId}`, message);
    this.toggleLoading(false);
  }
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/add-to-registry/AddToRegistryController.js